/* eslint-disable no-unused-vars */
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { routes } from 'config';
import { saveLocalStorageItem } from 'utils';
import { StatusCounter } from './components/StatusCounter/StatusCounter';
import { PerformanceCard } from './components/PerformanceCard/PerformanceCard';
import { PerformanceSection } from './components/PerformanceSection/PerformanceSection';
import { dashboardAPI } from 'services';
import { METRICS_ADVERTISER, METRICS_PUBLISHER } from 'constants';

const Publisher = ({ dateFrom$, dateTo$ }) => {
  const timePeriod = { from: dateFrom$?.value, to: dateTo$?.value };

  const { data: statusData, isFetching: isFetchingStatusData } =
    dashboardAPI.useGetPublisherAppStatusCountersQuery(timePeriod, {
      skip: !timePeriod.from || !timePeriod.to,
    });
  const {
    data: graphData,
    isFetching: isFetchingGraphData,
    isError: isGraphError,
  } = dashboardAPI.useGetPublisherPerformanceCardsQuery(timePeriod, {
    skip: !timePeriod.from || !timePeriod.to,
  });

  return (
    <Wrap>
      <GridWrap cols={2} style={{ height: '100%' }}>
        <VerticalGridWrap cols={2}>
          {(isFetchingStatusData || statusData) && (
            <>
              <StatusCounter
                title='Monetising Apps'
                value={statusData?.monetising}
                isFetching={isFetchingStatusData}
                numCols={1}
                iron='play'
                type='green'
              />
              <StatusCounter
                title='Need SDK Integration'
                value={statusData?.pending}
                isFetching={isFetchingStatusData}
                numCols={1}
                icon='integration'
                type='red'
              />
            </>
          )}
          {(isFetchingGraphData || (graphData && !isGraphError)) &&
            METRICS_PUBLISHER.map(({ colName, label }) => (
              <PerformanceCard
                key={colName}
                label={label}
                value={graphData?.values[colName]}
                trend={graphData?.trends[colName]}
                change={graphData?.change[colName]}
                data={graphData?.data[colName]}
                isFetching={isFetchingGraphData}
              />
            ))}
        </VerticalGridWrap>
        <PerformanceSection.Publisher dateFrom$={dateFrom$} dateTo$={dateTo$} />
      </GridWrap>
    </Wrap>
  );
};

const Advertiser = ({ dateFrom$, dateTo$ }) => {
  const navigate = useNavigate();
  const goToCampaigns = (status) => {
    saveLocalStorageItem({ key: 'tableState', field: 'statusFilter', value: status });
    navigate(routes.list.find((route) => route.id === 'campaign').url);
  };
  const timePeriod = { from: dateFrom$?.value, to: dateTo$?.value };

  const { data: statusData, isFetching: isFetchingStatusData } =
    dashboardAPI.useGetCampaignStatusCountersQuery(timePeriod, {
      skip: !timePeriod.from || !timePeriod.to,
    });
  const {
    data: graphData,
    isFetching: isFetchingGraphData,
    isError: isGraphError,
  } = dashboardAPI.useGetAdvertiserPerformanceCardsQuery(timePeriod, {
    skip: !timePeriod.from || !timePeriod.to,
  });

  return (
    <Wrap>
      <GridWrap cols={5}>
        {(isFetchingStatusData || statusData) && (
          <>
            <StatusCounter
              title='Active Campaigns'
              onClick={() => goToCampaigns('active')}
              value={statusData?.active}
              isFetching={isFetchingStatusData}
              numCols={2}
              icon='play'
              type='green'
            />
            <StatusCounter
              title='Paused'
              onClick={() => goToCampaigns('paused')}
              value={statusData?.paused}
              isFetching={isFetchingStatusData}
              numCols={2}
              icon='pause'
              type='yellow'
            />
            <StatusCounter
              title='Suspended'
              onClick={() => goToCampaigns('suspended')}
              value={statusData?.suspended}
              isFetching={isFetchingStatusData}
              numCols={1}
              icon='suspended'
              type='red'
            />
          </>
        )}
        {(isFetchingGraphData || (graphData && !isGraphError)) &&
          METRICS_ADVERTISER.map(({ colName, label }) => (
            <PerformanceCard
              key={colName}
              label={label}
              value={graphData?.values[colName]}
              trend={graphData?.trends[colName]}
              change={graphData?.change[colName]}
              data={graphData?.data[colName]}
              isFetching={isFetchingGraphData}
            />
          ))}
      </GridWrap>
      <Seporator />
      <GridWrap cols={2}>
        <PerformanceSection.Advertiser dateFrom$={dateFrom$} dateTo$={dateTo$} />
      </GridWrap>
    </Wrap>
  );
};

const Wrap = styled.div`
  min-height: 100%;
`;

const Seporator = styled.div`
  height: 8px;
  width: 100%;
`;

const GridWrap = styled.div`
  display: grid;
  grid-template-columns: ${({ cols }) => `repeat(${cols}, minmax(0, 1fr))`};
  gap: 8px;

  > * {
    min-width: 0;
  }
`;

const VerticalGridWrap = styled.div`
  display: grid;
  grid-template-columns: ${({ cols }) => `repeat(${cols}, minmax(0, 1fr))`};
  grid-template-rows: auto 1fr;
  gap: 8px;

  > * {
    min-width: 0;
  }
`;

export const DashboardMain = {
  Publisher,
  Advertiser,
};
